// platform.native actually hosts Node.js / Deno detection too
export * from './platform.native.js'
